module.exports = __webpack_public_path__ + "static/half-orc-male-AYAGWW-38997e78cc1eb42031bccd0ec0f4ce8a.png";